import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { cn } from "@/lib/cn";

export function FallbackImage({
  alt,
  className,
  fallbackClassName,
  src,
  objectClassName,
  label = "No image",
}: {
  alt: string;
  className?: string;
  fallbackClassName?: string;
  objectClassName?: string;
  src?: string | null;
  label?: string;
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <div
        aria-label={alt}
        className={cn(
          "flex items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-[radial-gradient(circle_at_top_left,_rgba(120,133,255,0.18),_transparent_34%),linear-gradient(180deg,rgba(15,23,42,0.95),rgba(8,10,20,1))] text-center",
          className,
          fallbackClassName,
        )}
        role="img"
      >
        <div className="flex flex-col items-center gap-2 px-4">
          <ImageOff className="h-5 w-5 text-slate-400" />
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">{label}</span>
        </div>
      </div>
    );
  }

  return <img alt={alt} className={cn(className, objectClassName)} onError={() => setFailed(true)} src={src} />;
}
